import { Link } from '@inertiajs/react'

export default function ConfirmationPending() {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-indigo-600 mb-2">Gosellgo</h1>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
          <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg className="w-8 h-8 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" />
            </svg>
          </div>

          <h2 className="text-xl font-semibold text-gray-900 mb-2">Bekräfta din e-postadress</h2>
          <p className="text-gray-600 mb-6">
            Vi har skickat ett bekräftelsemail till din e-postadress. Klicka på länken i mailet för att aktivera ditt konto och börja använda Gosellgo.
          </p>
          <p className="text-sm text-gray-500">
            Inget mail? Kontrollera din skräppost eller{' '}
            <Link href="/confirmation/new" className="text-indigo-600 hover:underline">
              skicka ett nytt bekräftelsemail
            </Link>
            .
          </p>
        </div>

        <p className="mt-6 text-sm text-gray-600">
          Har du redan ett bekräftat konto?{' '}
          <Link href="/sign_in" className="text-indigo-600 hover:underline">
            Logga in
          </Link>
        </p>
      </div>
    </div>
  )
}
